document.addEventListener('DOMContentLoaded', function() {
  // Function to get URL parameter by name
  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Extracting URL parameters
  const utmSource = getURLParameter('utm_source');
  const clickid = getURLParameter('click_id');
  const utmTerm = getURLParameter('utm_term');
  const utmCampaign = getURLParameter('utm_campaign');

  // Checking if utm_source is 'cashkaro'
  if (utmSource === 'cashkaro') {
    // Creating formData object
    const formData = {
      attributes: {
        'utm_source': utmSource,
        'click_id': clickid,
        'utm_term': utmTerm,
        'utm_campaign': utmCampaign
      }
    };

    // Making fetch request
    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => {
      if (!res.ok) {
        throw new Error('Network response was not ok ' + res.statusText);
      }
      return res.json();
    })
    .then((data) => {
      console.log(data);
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
    });
  }
});
